var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFound tga-main-with-bar"},[_c('tg-header-bar'),_c('tg-scroll-view',{attrs:{"direction":"vertical","scroller":"window","gap":false}},[_c('tg-flexbox',[_c('tg-not-found')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }